import { BaseTariffCard } from './base-tariff-card';
import { MinutesTariffCard } from './minutes-tariff-card';

export const getTariffCardComponent = (packageType?: string | null) => {
  if (packageType === 'minutes') {
    return MinutesTariffCard;
  }

  return BaseTariffCard;
};
